module.exports = __webpack_public_path__ + "dc36938242cc79eee7a903944b9b722d.svg";